import { Link } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useSubscriptionStore } from '@/stores/subscriptionStore';

function getDaysRemaining(trialEndsAt: string | undefined): number {
  if (!trialEndsAt) return 0;
  const diff = new Date(trialEndsAt).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export default function TrialBanner() {
  const status = useSubscriptionStore((s) => s.status);
  const trialEndsAt = useSubscriptionStore((s) => s.trial_ends_at);

  if (status !== 'trial') return null;

  const daysRemaining = getDaysRemaining(trialEndsAt);

  let colorClass = 'bg-blue-50 border-blue-200 text-blue-800';
  if (daysRemaining <= 3) {
    colorClass = 'bg-red-50 border-red-200 text-red-800';
  } else if (daysRemaining <= 7) {
    colorClass = 'bg-amber-50 border-amber-200 text-amber-800';
  }

  return (
    <div className={`flex items-center justify-between border-b px-4 py-2 text-sm ${colorClass}`}>
      <span>
        {daysRemaining > 0
          ? `Your free trial ends in ${daysRemaining} day${daysRemaining !== 1 ? 's' : ''}.`
          : 'Your free trial has ended.'}
        {' '}Confirm your plan to keep access.
      </span>
      <Link
        to={ROUTES.SUBSCRIPTION_CONFIRM}
        className="ml-4 shrink-0 font-semibold underline underline-offset-2 hover:opacity-80"
      >
        Confirm your plan →
      </Link>
    </div>
  );
}
